import { notification } from 'antd'

import SpaceAPI from '@apis/branch/space'

import ConfirmModal from '@components/molecules/ConfirmModal'

type Props = {
  hqId: number
  branchId: number
  spaceId?: number
  visible: boolean
  onClose: () => void
  onDone: () => void
}

export default function SpaceDeleteModal({ hqId, branchId, spaceId, visible, onClose, onDone }: Props): JSX.Element {
  const onConfirm = async () => {
    if (!spaceId) return

    await SpaceAPI.deleteSpace({ hqId, branchId, spaceId })
    notification.success({ message: '삭제 되었습니다.' })
  }

  return (
    <ConfirmModal
      visible={visible}
      title="공간 삭제"
      description="공간이 삭제되면 계약 및 청구 관련 기능이 정상작동되지 않을 수 있습니다."
      okText="삭제"
      onConfirm={onConfirm}
      onDone={onDone}
      onClose={onClose}
    />
  )
}
